module.exports = __webpack_public_path__ + "fonts/iconfont.de9f0496.ttf";